import React, { useReducer, useEffect, useContext, useState } from 'react'
import { Grid, Paper, Typography, Box, Button } from '@material-ui/core'
import MaterialTable from 'material-table'
import moment from 'moment';
import tableIcons, { options } from 'components/universal/table_attributes';
import TableAction from 'actions/table_actions'
import { ToastMessageContext } from "lib/contexts/message_context";
import { LineMaintainenceServices } from 'lib/services/api/dashboard/line_maintenance';
import { getOrganisationId } from 'lib/utils/common_utils';
import tableReducer, {
    INITIAL_TABLE_STATE,
} from 'reducers/table_reducer';
import DownloadIcon from '@material-ui/icons/CloudDownloadOutlined';
import { downloadCsvFileFromUrlWithBase } from 'lib/utils/helperFunctions';
import DownloadCsv from 'components/DownloadCsv';


function Chargeable({ selectedFilters, selectedBase, filterData, startDate, endDate }) {
    const [action, setAction] = useState('')
    const [tableState, dispatch] = useReducer(tableReducer, INITIAL_TABLE_STATE);
    const { page, pageSize } = tableState;
    const [chargeableData, setChargeableData] = useState([])
    const message = useContext(ToastMessageContext)
    const [loading, setLoading] = useState(false)
    const [totalCount, setTotalCount] = useState(10);
    let sDate = startDate ? filterData.startdate : moment().subtract(7, 'days').format("YYYY-MM-DD")
    let eDate = endDate ? filterData.enddate : moment().format("YYYY-MM-DD")

    const tableOptions = {
        ...options,
        page: page,
        total: totalCount,
        pageSize: pageSize,
        search: false,
        sort: false,
        toolbar: false

    };
    const getChargeableListing = async () => {
        setLoading(true)
        const params = {
            organisation_id: getOrganisationId(),
            dial_name: "charges",
            page: page + 1,
            limit: pageSize,
            start_date: sDate,
            end_date: eDate,

        }
        selectedBase.forEach((item, index) => params[`base_station_id[${[index]}]`] = item)
        selectedFilters.forEach((item, index) => params[`line_customer_id[${[index]}]`] = item)
        await LineMaintainenceServices.getPerformanceListing(params).then((response) => {
            setChargeableData(response.data)
            setTotalCount(response.total_count);
        }).catch((err) => {
            message.showToastMessage({
                message: "Something went wrong",
                variant: "error",
            })
        }).finally(() => {
            setLoading(false)
        })

    }

    useEffect(() => {
        getChargeableListing()
    }, [page, pageSize, selectedFilters, selectedBase, filterData])

    const columns = [
        {
            title: 'Base',
            field: 'base_station',
            width: '30%',
            headerStyle: {
                width: '10%',
                textAlign: 'left',

                paddingLeft: '20px'
            },
            cellStyle: {
                width: '10%',
                textAlign: 'left',
                paddingLeft: '20px'

            },
        },
        {
            title: 'Head Count',
            field: 'head_count',


        },
        {
            title: 'Top Ups',
            field: 'top_ups',


        },
        {
            title: 'Whl Changes',
            field: 'tx_inflations',


        },
        {
            title: 'Medium Steps',
            field: 'medium_steps',


        },
        {
            title: 'Large Steps',
            field: 'large_steps',


        },
        {
            title: 'High Lift (Hrs)',
            field: 'high_lifts',


        },
        {
            title: 'APU Access Stand',
            field: 'gnd_equip',

        },

        {
            title: 'Tows',
            field: 'tows',
        },
        {
            title: 'ADHOC Events',
            field: 'adhoc_events',

        },


    ]

    //const download Csv
    const handleDownloadCsv = async () => {
        // console.log('clicked======')
        setLoading(true)

        const params = {
            organisation_id: getOrganisationId(),
            dial_name: "charges",
            start_date: sDate,
            end_date: eDate,
            download_csv: true
        }
        selectedBase.forEach((item, index) => params[`base_station_id[${[index]}]`] = item)
        selectedFilters.forEach((item, index) => params[`line_customer_id[${[index]}]`] = item)
        await LineMaintainenceServices.getPerformanceListing(params).then((response) => {
            downloadCsvFileFromUrlWithBase(response.file)
        }).catch((err) => {
            message.showToastMessage({
                message: "Something went wrong",
                variant: "error",
            })
        }).finally(() => {
            setLoading(false)
        })
    }
    return (
        <>
            <Grid xs={12} >

                <MaterialTable
                    style={{ boxShadow: '0px 1px 3px #00000033', paddingRight: '0px' }}
                    icons={tableIcons}
                    title={<Typography color="primary" variant="subtitle2">
                        Chargeable
                    </Typography>}
                    options={tableOptions}
                    data={chargeableData}
                    columns={columns}
                    isLoading={loading}
                    onChangePage={(page) => {
                        TableAction.setPage(dispatch, page);
                    }}
                    onChangeRowsPerPage={(pageSize) => {
                        TableAction.setPageSize(dispatch, pageSize);
                    }}
                    onSearchChange={(search) => {
                        TableAction.setSearchText(dispatch, search);
                    }}
                    totalCount={totalCount}
                    page={page}

                />
                <DownloadCsv
                    startDate={sDate}
                    endDate={eDate}
                    isDateFilterPresent={true}
                    onDownload={handleDownloadCsv}
                    format={"YYYY-MM-DD"}
                />
            </Grid>
        </>
    )
}

export default Chargeable